import { useFlags } from '@joor/launchdarkly-react-client-sdk'

import { BrandJOORPayDisabledView } from './components/EmptyPayView/EmptyPayViews'
import { Invoice } from './components/Invoice/Invoice'
import { checkProBrandConditions } from './utils'

type ProBrandPayViewProps = {
  paymentProvider: {
    paymentProvider: string
    retailersCanSeeInvoices: boolean
  } | null
}

const ProBrandPayView = ({ paymentProvider }: ProBrandPayViewProps) => {
  const { joorPayUseReach } = useFlags()

  const shouldRender = checkProBrandConditions({
    joorPayUseReach,
    paymentProvider: paymentProvider ? paymentProvider?.paymentProvider : null,
  })

  if (shouldRender === 'invoice') {
    return <Invoice />
  }

  if (shouldRender === 'disabled') {
    return <BrandJOORPayDisabledView />
  }

  return null
}

export default ProBrandPayView
